<template>
  <Modal v-if="showModalDeleteUser" @close="$emit('closeModal')">
    <div class="deleteUser">
      <div class="deleteUser__header">
        <span class="title">{{ $t('deleteUser') }}</span>
        <img
          src="@/assets/icons/Close.svg"
          alt=""
          @click="$emit('closeModal')"
        />
      </div>
      <div class="deleteUser__body">
        <p class="text">
          {{ $t('youWantDelete') }}
          <span> {{ user.firstName }} {{ user.lastName }}? </span>
          {{ $t('thisChangeCannotBeUndone') }}
        </p>
      </div>
      <div class="buttons">
        <Button
          variant="redButton"
          :title="$t('delete')"
          @click="$emit('deleteUserRequest')"
        />
        <Button
          variant="notBordered"
          :title="$t('cancel')"
          @click="$emit('closeModal')"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'DeleteUser',
  props: ['showModalDeleteUser', 'user']
})
export default class DeleteUser extends Vue {}
</script>

<style lang="scss" scoped>
.deleteUser {
  width: 460px;
  height: 136px;
  padding: 24px;
  .deleteUser__header {
    display: flex;
    justify-content: space-between;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
    }
    img {
      cursor: pointer;
    }
  }
  .deleteUser__body {
    padding: 24px 0;
    .text {
      color: $label;
      font-size: $fourteenSize;
      .span-box {
        color: $label;
        font-weight: 600;
        font-family: 'Ubuntu-Medium';
      }
    }
  }
}
</style>
